// theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 768, // Custom breakpoint for small screens
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default theme;
